module.exports = __webpack_public_path__ + "media/images/header-a7bfb6613c4d92eb9a1882ddefa6e0cb.png";